<script>
import ConsentBoxField from '@phoenix/mixins/components/form/fields/ConsentBoxField';

export default {
  mixins: [ConsentBoxField],
};
</script>

<template>
  <section class="section section--tight mb-4">
    <div>
      <div>
        <div>
          <h2 class="sgphx-h5">{{ consentData.texts.title }}</h2>
          <div v-if="consentData.texts.header" class="pt-2">{{ consentData.texts.header }}</div>
        </div>
      </div>
      <div>
        <div class="mt-4">
          <h2 class="sgphx-h5">{{ $t('Form.consent.item') }}</h2>
          <div class="pt-2" v-html="consentData.texts.items" />
        </div>
        <div class="mt-4">
          <h2 class="sgphx-h5">{{ $t('Form.consent.purpose') }}</h2>
          <div class="pt-2" v-html="consentData.texts.purposes" />
        </div>
        <div class="mt-4">
          <h2 class="sgphx-h5">{{ $t('Form.consent.retentionPeriod') }}</h2>
          <div class="pt-2" v-html="consentData.texts.retentionPeriod" />
        </div>
      </div>
      <div>
        <div>{{ consentData.texts.footer }}</div>
        <h2 class="sgphx-h5 sgphx-mt-base">
          {{ $t('Form.consent.question') }}&nbsp;
          <abbr v-if="consentData.required" title="Required"> * </abbr>
        </h2>
        <div>
          <form-group :show-label="false" :attrs="consentData" is-sgphx>
            <radio-list-field v-model="value" :inline="true" is-sgphx />
          </form-group>
        </div>

        <div v-if="consentData.hasMarketingConsents" class="mt-4">
          <h2 class="sgphx-h5">
            {{ consentData.texts.channelsLabel }}&nbsp;
            <abbr v-if="consentData.value === 'true'" title="Required"> * </abbr>
          </h2>

          <marketing-consents
            v-model="marketingConsentsValue"
            :attrs="marketingConsentsField"
            :has-global-consent="false"
            is-sgphx
          />
        </div>
      </div>
    </div>
  </section>
</template>
